import { PACKING_APPROVAL_FAIL, PACKING_APPROVAL_REQUEST, PACKING_APPROVAL_SUCCESS } from "../../../actions/Packing/packingApproval/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const packingApprovalReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case PACKING_APPROVAL_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case PACKING_APPROVAL_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case PACKING_APPROVAL_FAIL:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
